<template>
  <div>
  <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
    <h3 class="text-white"> {{ $t('Click on the Left or the Right to select.') }} </h3>
    <div class="comparetwo-wrapper py-3">
      <div class="comparetwo-responsive">
          <!-- First Item -->
          <div class="comparetwo-item mb-1 mr-2 relative cursor-pointer" v-on:click="(leftChosen = !leftChosen), (rightChosen = false)" v-bind:class="{active: leftChosen}">
            <div class="flex-grow h-full align-middle">
              
              <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                  <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="(attributes, index) in itemsarray[0].attributes">
                    <span class="label container">{{ attributes.label }}</span>
                    <span class="description" v-html="attributes.text"></span>
                  </div>
              </div>
            </div>
          </div>
          <!-- Labels  -->
          <div class="labels-container comparetwo-item relative">
            <div class="flex-grow h-full align-middle">
              <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                  <div class="flex-1 flex flex-col flex-grow even:bg-gray-300 odd: bg-gray-100 justify-center relative" v-for="(labels, index) in labelsarray">
                      <span class="label container">{{ labels.label }}</span>
                  </div>
              </div>
            </div>
          </div>
          <!-- Second Item -->
          <div class="comparetwo-item mb-1 mr-2 relative cursor-pointer" v-on:click="(rightChosen = !rightChosen), (leftChosen = false)" v-bind:class="{active: rightChosen}">
            <div class="flex-grow h-full align-middle">
              
              <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                  <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="(attributes, index) in itemsarray[1].attributes">
                      <span class="label container">{{ attributes.label }}</span>
                      <span class="description" v-html="attributes.text"></span>
                  </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  
      <div class="submit-button-wrapper">
        <transition name="fade" mode="in-out">
          <div v-if="leftChosen" class="w-full">
            <input type="hidden" name="submitLeft" :value="itemsarray[0].id">
            <button id="submitLeft" @click="submitLeft" type="submit" class="absolute left-0 right-0 m-auto px-5 py-2">{{ $t('Choose') }} {{ itemsarray[0].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
          </div>
        </transition>
        <transition name="fade" mode="in-out">
          <div v-if="rightChosen" class="w-full">
            <input type="hidden" name="submitRight" :value="itemsarray[1].id">
            <button id="submitRight" @click="submitRight" type="submit" class="absolute left-0 right-0 m-auto px-5 py-2">{{ $t('Choose') }} {{ itemsarray[1].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
          </div>
        </transition>
      </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'

  export default {
        props: {
            array: '',
            labels: '',
            route:'',
        },
        data() {
          return {
            leftChosen: false,
            rightChosen: false,
            itemsarray: this.array,
            labelsarray: this.labels,
          }
        },
        methods: {
            submitLeft: function (event) {
              $( "#submitLeft").addClass( "loading" );
              axios.put(this.route, { 
                results: [this.itemsarray[0].id] 
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            },
            submitRight: function (event) {
              $( "#submitRight").addClass( "loading" );
              axios.put(this.route, { 
                results: [this.itemsarray[1].id]
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
